{
  "class": {
    "customer": "Customers",
    "user": "Users",
    "project_time": "Project time and notes",
    "ai_conversation": "AI assistant conversations"
  },
  "trigger": {
    "ARCHIVED": "archived",
    "DEACTIVATED": "deactivated"
  },
  "action": {
    "ANONYMISE": "Anonymise",
    "PURGE_FILES": "Delete attached files",
    "ANONYMISEHint": "Personal details are removed; the record and its documents stay.",
    "PURGE_FILESHint": "Attached files are deleted; the record stays."
  },
  "rules": {
    "title": "Retention rules",
    "body": "How long personal data is kept after its record is archived, and what happens then. A record on legal hold is never touched.",
    "moduleOff": "Module off: retention still runs",
    "moduleOffHint": "Retention keeps running for a module the company has turned off, so data is never kept longer than allowed.",
    "later": "Available in a later release",
    "laterBody": "Records of this kind cannot be anonymised yet, so this rule stays off.",
    "enabled": "Anonymise once the period ends after the record is {{trigger}}",
    "period": "Keep for",
    "floorHint": "At least {{n}} months (the legal minimum).",
    "months": "months",
    "action": "Then",
    "onlyAction": "The only action allowed for this kind of data.",
    "offNote": "Off: nothing is anonymised automatically. Requests from people can still be answered.",
    "save": "Save retention rules",
    "saved": "Retention rules saved",
    "errors": {
      "belowFloor": "Enter at least {{n}} months, the legal minimum for this data.",
      "wholeNumber": "Enter a whole number of months.",
      "tooLong": "Enter at most {{max}} months."
    }
  },
  "runs": {
    "loading": "Loading…",
    "failed": "The last run could not be loaded.",
    "summary": "Last run {{date}}: {{due}} due, {{queued}} queued for anonymising, {{held}} kept by a legal hold.",
    "never": "Retention has not run yet. It runs every night."
  },
  "register": {
    "title": "Processing register",
    "body": "What personal data the company holds, why, and for how long at least.",
    "class": "Data",
    "basis": "Legal basis",
    "floor": "Kept at least",
    "rule": "Retention",
    "months": "{{n}} months",
    "on": "On, after {{n}} months",
    "off": "Off",
    "failed": "The register could not be loaded."
  },
  "holds": {
    "title": "Legal holds",
    "settingsBody": "Keep a record out of retention while a dispute, audit or claim is open.",
    "place": "Place hold",
    "views": "Hold views",
    "active": "Active",
    "lifted": "Lifted",
    "empty": {
      "title": "No records are on hold",
      "body": "Place a hold to stop a record from being anonymised while a dispute or audit is open.",
      "lifted": "No hold has been lifted yet"
    },
    "placedBy": "Placed {{date}} by {{name}}",
    "placedOn": "Placed {{date}}",
    "liftedBy": "Lifted {{date}} by {{name}}",
    "liftedOn": "Lifted {{date}}",
    "lift": "Lift",
    "liftNamed": "Lift hold on {{name}}",
    "counter": "{{n}} of {{max}} characters.",
    "reason": "Reason",
    "reasonHint": "Say what the hold is for, such as the case or audit.",
    "placeTitle": "Place a legal hold",
    "placeBody": "While the hold is active, the record is never anonymised, by retention or by a request.",
    "placed": "{{name}} is on hold",
    "liftTitle": "Lift the hold on {{name}}?",
    "liftBody": "Retention applies to the record again. A lifted hold cannot be placed back; place a new one if needed.",
    "liftReason": "Why the hold ends",
    "liftReasonHint": "Kept in the audit trail.",
    "liftedToast": "Hold on {{name}} lifted",
    "errors": {
      "subject": "Choose the record to hold.",
      "reason": "Write at least {{n}} characters.",
      "already": "This record is already on hold.",
      "unknown": "This record no longer exists or was anonymised.",
      "alreadyLifted": "This hold was already lifted. Refresh to see it."
    }
  },
  "subject": {
    "type": "Kind of record",
    "customer": "Customer",
    "user": "User",
    "pickCustomer": "Search by name, code or mobile",
    "customerHint": "Archived customers are included.",
    "userHint": "Active users of the company.",
    "removed": "Removed record",
    "notYet": "Not verified yet"
  },
  "clock": {
    "dayOf": "Day {{day}} of {{total}}",
    "closedOn": "Closed {{date}}",
    "closed": "Closed",
    "overdue_one": "Overdue by {{n}} day",
    "overdue_other": "Overdue by {{n}} days",
    "wasDue": "Was due {{date}}",
    "dueToday": "Due today",
    "dueIn_one": "Due in {{n}} day",
    "dueIn_other": "Due in {{n}} days",
    "due": "due {{date}}",
    "answerBy": "Answer by {{date}}",
    "rule": "The law gives 45 calendar days from the day the request was received; that day is day 1."
  },
  "status": {
    "RECEIVED": "Received",
    "VERIFIED": "Verified",
    "IN_PROGRESS": "In progress",
    "COMPLETED": "Completed",
    "REFUSED": "Refused"
  },
  "kind": {
    "ACCESS": "Access to data",
    "CORRECTION": "Correction",
    "ERASURE": "Erasure",
    "OBJECTION": "Objection to processing",
    "PORTABILITY": "Copy to take elsewhere",
    "CONSENT_WITHDRAWAL": "Consent withdrawn"
  },
  "channel": {
    "EMAIL": "E-mail",
    "LETTER": "Letter",
    "IN_PERSON": "In person",
    "PHONE": "Phone",
    "OTHER": "Other"
  },
  "fields": {
    "requester": "Requester",
    "requesterName": "Requester’s name",
    "requesterContact": "How to reach them",
    "kind": "Request",
    "channel": "Received by",
    "receivedOn": "Received on",
    "dueOn": "Answer by",
    "clock": "Time left",
    "status": "Status",
    "assignee": "Handled by",
    "unassigned": "Not assigned",
    "subject": "Whose data",
    "details": "Details"
  },
  "queue": {
    "title": "Privacy requests",
    "intro": "Requests from people about their personal data. Each one must be answered within 45 calendar days.",
    "log": "Log request",
    "views": "Request views",
    "view": {
      "open": "Open",
      "dueSoon": "Due in 7 days",
      "overdue": "Overdue",
      "closed": "Closed"
    },
    "searchPlaceholder": "Search by requester",
    "searchLabel": "Search requests",
    "clearSearch": "Clear search",
    "clearFilters": "Clear filters",
    "allKinds": "All requests",
    "tableLabel": "Privacy requests",
    "empty": {
      "filtered": "No requests match",
      "open": "No open requests",
      "openBody": "When someone asks about their personal data by e-mail, letter, phone or in person, log it here to start the 45-day clock.",
      "dueSoon": "Nothing is due in the next 7 days",
      "overdue": "No request is overdue",
      "closed": "No request has been closed yet"
    }
  },
  "log": {
    "title": "Log a privacy request",
    "body": "Record a request as it reached the company. The 45-day clock starts on the day it was received.",
    "submit": "Log request",
    "kindHint": "What the person is asking for.",
    "contactHint": "An e-mail address, phone number or postal address.",
    "receivedHint": "Back-date it if it arrived earlier; it cannot be in the future.",
    "dueHint": "Must be answered by {{date}}.",
    "detailsHint": "Optional: what they said, references, documents seen.",
    "logged": "Request from {{name}} logged",
    "errors": {
      "future": "The received date cannot be in the future."
    }
  },
  "actions": {
    "verify": "Verify",
    "start": "Start work",
    "complete": "Complete",
    "refuse": "Refuse",
    "export": "Export data (JSON)",
    "exporting": "Exporting…",
    "exportNeedsSubject": "Verify whose data it is first."
  },
  "detail": {
    "request": "Request",
    "refusedTitle": "Refused",
    "exported": "Data exported",
    "conflict": {
      "title": "Someone else changed this request",
      "body": "Reload to see where it stands now, then try again.",
      "reload": "Reload"
    },
    "held": {
      "title": "The record is on legal hold",
      "body": "It cannot be erased while the hold is active. Lift the hold, or refuse the request with a reason.",
      "link": "Open legal holds"
    },
    "referenced": {
      "title": "The request was refused",
      "body": "Issued documents still refer to this record, so it is kept for legal and tax records. The reason has been recorded."
    }
  },
  "verify": {
    "title": "Verify the request",
    "body": "Confirm who the person is and choose the record that holds their data.",
    "pickSubject": "Choose whose data this is."
  },
  "start": {
    "title": "Start work on this request?",
    "body": "The request moves to In progress. The clock keeps running."
  },
  "complete": {
    "title": "Complete this request?",
    "body": "Confirm the person has been answered. A completed request cannot be changed.",
    "erasureBody": "The record’s personal details will be removed for good and its history will show them as redacted. This cannot be undone.",
    "erasureConfirm": "Erase and complete"
  },
  "refuse": {
    "title": "Refuse this request?",
    "body": "Tell the requester why. A refused request cannot be reopened.",
    "reason": "Reason for refusing",
    "needReason": "Write the reason to tell the requester.",
    "counter": "{{n}} of {{max}} characters."
  },
  "toast": {
    "verified": "Request verified",
    "started": "Work started",
    "completed": "Request completed",
    "refused": "Request refused"
  },
  "timeline": {
    "title": "Timeline",
    "empty": "Nothing has happened yet.",
    "system": "The system",
    "event": {
      "RECEIVED": "{{actor}} logged the request",
      "VERIFIED": "{{actor}} verified the requester and the record",
      "IN_PROGRESS": "{{actor}} started work",
      "COMPLETED": "{{actor}} completed the request",
      "REFUSED": "{{actor}} refused the request"
    }
  }
}
